import styled, { keyframes } from 'styled-components';
import { COLOR_SYSTEM } from 'components/design/design-system';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideUp = keyframes`
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9998;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  user-select: none;
`;

export const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  animation: ${fadeIn} 0.2s ease-in-out;
`;

export const KeypadPanel = styled.div`
  position: relative;
  background: ${COLOR_SYSTEM.get('Gray')?.[0] || '#ffffff'};
  border-radius: 20px 20px 0 0;
  padding: 20px 16px;
  padding-bottom: max(20px, env(safe-area-inset-bottom));
  animation: ${slideUp} 0.3s ease-in-out;
`;

export const DisplayRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
`;

export const Dot = styled.span<{ $filled: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${(props) =>
    props.$filled
      ? COLOR_SYSTEM.get('Gray')?.[800]
      : COLOR_SYSTEM.get('Gray')?.[200]};
  transition: background 0.15s ease;
`;

export const KeyGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  max-width: 320px;
  margin: 0 auto;
`;

export const KeyButton = styled.button<{ $decoyActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  min-width: 48px;
  border: none;
  border-radius: 12px;
  background: ${(props) =>
    props.$decoyActive ? COLOR_SYSTEM.get('Gray')?.[200] : COLOR_SYSTEM.get('Gray')?.[50]};
  color: ${COLOR_SYSTEM.get('Gray')?.[800]};
  font-size: 22px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.1s ease;

  &:active {
    background: ${COLOR_SYSTEM.get('Gray')?.[200]};
  }
`;

export const ActionButton = styled(KeyButton)<{ $variant?: 'delete' | 'confirm' }>`
  background: ${(props) =>
    props.$variant === 'confirm'
      ? COLOR_SYSTEM.get('Blue')?.[400]
      : 'transparent'};
  color: ${(props) =>
    props.$variant === 'confirm'
      ? '#ffffff'
      : COLOR_SYSTEM.get('Gray')?.[600]};
  font-size: 16px;
  font-weight: 500;

  &:active {
    background: ${(props) =>
      props.$variant === 'confirm'
        ? COLOR_SYSTEM.get('Blue')?.[500]
        : COLOR_SYSTEM.get('Gray')?.[100]};
  }
`;
